import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import Divider from 'dashboard/components/Divider';
import FormUpdateAccountNew from 'dashboard/forms/FormUpdateAccountNew';
import { ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { Container } from 'dashboard/layouts/ShowViewLayoutV2';
import { Account } from 'dashboard/models/account';
import { AccountType } from 'dashboard/models/account-type';
import { AccountState } from 'dashboard/redux/slices/account';
import { Title } from 'design-system/components/Card/Header';
import { FieldsMap, FieldType } from 'lib/fields';

const StyledNewModalContainer = styled(ModalContainer).attrs(() => ({ size: 'lg' }))`
  padding-top: 0;
`;

const StyledNewModalHeader = styled(ModalHeader)`
  padding: ${Spacing[3]} ${Spacing[4]};
`;

const StyledDivider = styled(Divider)`
  margin-top: 0;
  margin-bottom: 0;
`;

interface EditAccountModalNewProps {
  onSubmit: (values: FieldsMap) => Promise<void>;
  account: Account;
  relations: AccountState['relations'];
  hideModal: () => void;
  accountType: AccountType;
}

const EditAccountModalNew = ({
  onSubmit,
  account,
  relations,
  hideModal,
  accountType,
}: EditAccountModalNewProps) => {
  const filterFields = (account: Account): FieldsMap => {
    const fieldsMap: FieldsMap = {};

    Object.entries(account.attributes.fields).forEach(([key, field]) => {
      switch (field.type) {
        case FieldType.Boolean:
        case FieldType.Choices:
        case FieldType.Date:
        case FieldType.Datetime:
        case FieldType.Integer:
        case FieldType.Number:
        case FieldType.MultiChoices:
        case FieldType.String:
        case FieldType.File:
        case FieldType.Hash:
          fieldsMap[key] = field;
          break;
        default:
          break;
      }
    });

    return fieldsMap;
  };

  return (
    <Container>
      <StyledNewModalContainer>
        <StyledNewModalHeader data-test='edit-account-modal__header' onClose={hideModal}>
          <Title>Update fields</Title>
        </StyledNewModalHeader>
        <StyledDivider full />
        <FormUpdateAccountNew
          fields={filterFields(account)}
          accountSchemas={accountType.attributes['field-schemas']}
          relations={relations}
          onSubmit={onSubmit}
          hideModal={hideModal}
        />
      </StyledNewModalContainer>
    </Container>
  );
};

export default EditAccountModalNew;
